import type { IAppConfigState } from './interfaces';

const ENV = (import.meta as any).env;

export const APP_CONFIG_STORAGE_KEY = `${ENV?.VITE_APP_ORG || 'app'}_app_config`;

const isIsoDate = (value: unknown): value is string =>
  typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value);

export function normalizeAppConfig(input: any): Pick<IAppConfigState, 'calendar' | 'source'> | null {
  const upperBound = input?.calendar?.upperBound;
  if (!isIsoDate(upperBound)) return null;

  const source =
    input?.source === 'tenant_config' || input?.source === 'default'
      ? input.source
      : null;

  return {
    calendar: { upperBound },
    source,
  };
}

export function readCachedAppConfig(): Pick<IAppConfigState, 'calendar' | 'source'> | null {
  try {
    const raw = localStorage.getItem(APP_CONFIG_STORAGE_KEY);
    if (!raw) return null;
    return normalizeAppConfig(JSON.parse(raw));
  } catch {
    return null;
  }
}

export function writeCachedAppConfig(config: Pick<IAppConfigState, 'calendar' | 'source'>): void {
  try {
    localStorage.setItem(APP_CONFIG_STORAGE_KEY, JSON.stringify(config));
  } catch {
    // localStorage may be unavailable in private mode or restricted WebViews.
  }
}
